{
    "SCOPEASSIGNMENT_CME": "CME:",
    "SCOPEASSIGNMENT_FilterRecursively": "Rekursiv filtern:",
    "SCOPEASSIGNMENT_TelServer": "Telefonie-Server:",
    "SCOPEASSIGNMENT_Partition": "Teilung:",
    "NAME": "ScopeAssignment"
}